
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';

import {
    align,
    display,
    whiteSpace,
    width
} from '../../../../../../../commonStyles.js';
import styles from './styles.js';

const Dropdown = ({
    filter,
    filterIndex,
    filterGroup,
    filterGroupCollectionIndex,
    filterGroupIndex,
    handleFilterChange,
    isDisabled
}) => {
    return (
        <div className={css(display.table, width.full)}>
            <div className={css(display.tableCell, width.half, align.verticalAlignMiddle, whiteSpace.normal)}>
                <span
                    className={
                        isDisabled ?
                            css(styles.disabledText) :
                            css(styles.text)
                    }
                >
                    <span>
                        {filter.title}
                    </span>
                </span>
            </div>
            <div className={css(display.tableCell, width.half, align.verticalAlignMiddle)}>
                <div className={css(styles.selectContainer, styles.selectContainerBlock)}>
                    <select
                        className={
                            isDisabled ?
                                css(styles.disabledSelect) :
                                css(styles.select)
                        }
                        data-filter-index={filterIndex}
                        data-filter-group-index={filterGroupIndex}
                        data-filter-group-collection-index={filterGroupCollectionIndex}
                        data-input-type={filterGroup.inputType}
                        onChange={handleFilterChange}
                        value={
                            Number(filter.data.value) !== Number(filter.data.default) ?
                                Number(filter.data.value) : Number(filter.data.default)
                        }
                        disabled={isDisabled}
                    >
                        {
                            filter.options.map(option => (
                                <option
                                    key={shortid.generate()}
                                    value={option.value}
                                >
                                    {option.text}
                                </option>
                            ))
                        }
                    </select>
                </div>
            </div>
        </div>
    );
};

Dropdown.propTypes = {
    filter: PropTypes.object.isRequired,
    filterGroup: PropTypes.object.isRequired,
    filterGroupCollectionIndex: PropTypes.number.isRequired,
    filterGroupIndex: PropTypes.number.isRequired,
    filterIndex: PropTypes.number.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Dropdown/Dropdown.jsx